import script from "./load-more-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./load-more-button.vue?vue&type=script&setup=true&lang=ts"

import "./load-more-button.vue?vue&type=style&index=0&id=4b46c34c&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b46c34c"]])

export default __exports__